module.exports = '<div class="target very-different-class" popgun popgun-group="definitions">\n    {{ word.word }}\n</div>';